import {
  START_RECORDING_DATA,
  STOP_RECORDING_DATA,
} from "./record-video.actionTypes";

export function startRecordingData(data: any): any {
  return (dispatch: any) => {
    dispatch({
      type: START_RECORDING_DATA,
      payload: data,
    });
  };
}

export function stopRecordingData(data: any): any {
  return (dispatch: any) => {
    dispatch({
      type: STOP_RECORDING_DATA,
      payload: data,
    });
  };
}
